<template>
    <nav class="">
        <div class="relative flex flex-col items-start">
            <InertiaLink href="/players/me/rounds">
                <Icon name="swingu-white-logo" width="103" height="36" />
            </InertiaLink>
        </div>
        <ul class="ml-5 flex flex-grow">
            <li class="mr-5">
                <InertiaLink
                    href="/players/me/rounds"
                    :class="{
                        'border-b-[3px] border-b-primary-500 pb-6':
                            $page.component === 'rounds/list',
                    }"
                    class="relative h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
                >
                    Rounds
                </InertiaLink>
            </li>
            <li class="mr-5">
                <InertiaLink
                    href="/players/me"
                    :class="{
                        'border-b-[3px] border-b-primary-500 pb-6':
                            $page.component ===
                            'player/stats/advanced/aggregate-index',
                    }"
                    class="relative h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
                >
                    Advanced Stats
                </InertiaLink>
            </li>
            <li class="mr-5">
                <InertiaLink
                    href="/players/me/stats/basic"
                    :class="{
                        'border-b-[3px] border-b-primary-500 pb-6':
                            $page.component ===
                            'player/stats/basic/basic-index',
                    }"
                    class="relative h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
                >
                    Basic Stats
                </InertiaLink>
            </li>
            <li>
                <!-- This needs to use <a> instead of InertiaLink to avoid CORS issues in some edge cases -->
                <a
                    href="/players/me/clubs"
                    :class="{
                        'border-b-[3px] border-b-primary-500 pb-6':
                            $page.component ===
                                'legacy/Players/clubs/list-clubs' ||
                            $page.component ===
                                'legacy/Players/clubs/tracked-club',
                    }"
                    class="relative h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
                >
                    Clubs
                </a>
            </li>
        </ul>
        <ul class="flex place-content-end">
            <!-- <li class="mr-5 flex flex-row items-center group">
                <InertiaLink
                    href="/round"
                    class="flex h-4 items-center p-0 gap-[5px] group-hover:text-primary-500 transition-colors duration-500 ease-in-out"
                >
                    <div class="pt-2xs">
                        <PostIcon
                            class="group-hover:fill-primary-500 transition-colors duration-500 ease-in-out"
                        />
                    </div>
                    Post Score
                </InertiaLink>
            </li> -->
            <li class="group flex justify-end">
                <InertiaLink
                    href="/players/me/rounds"
                    class="header-nav__player-name flex items-center gap-[5px] p-3 transition-colors duration-500 ease-in-out group-hover:text-primary-500"
                >
                    {{ playerName }}
                    <Icon
                        name="caret-down"
                        width="10"
                        height="6"
                        class="text-white transition-colors duration-500 ease-in-out group-hover:text-primary-500"
                    />
                </InertiaLink>
                <AccountDropdown :expanded="false" class="top-[69px] z-[2]" />
            </li>
        </ul>
    </nav>
</template>

<script setup>
import AccountDropdown from "@components/app-swingu/account/account-dropdown.vue";
</script>

<script>
export default {
    components: {},
    props: {
        playerName: {
            type: String,
            default: "Unknown User",
        },
    },
};
</script>

<style scoped>
nav {
    @apply box-content items-baseline justify-between px-6 pt-[20px] pb-[18px] text-base font-medium leading-none text-white;
}
</style>
